module.exports = __webpack_public_path__ + "img/132.ee2148b6.jpg";